export const stylesCFS = {
  listFavsItem:{
    display: "grid",
    gridGap: "1px",
    gridTemplateColumns: "3fr 1fr 1fr",
    padding: "12px 16px 12px 16px",
    marginBottom: "24px",
    borderRadius: "4px",
    boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.24), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)",
  },
  alias:{
    fontFamily: "Amx-Bold",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "22px",
    color: "#50626C",
    padding: "0",
    margin: "0",
  },
  reference:{
    fontFamily: "Amx-Regular",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "22px",
      color: "#474747",
      padding: "0",
      margin: "0",
      with:"100%",
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '170px'
  },
  controlIcon:{
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonIcon:{
    border: "0",
    backgroundColor: "transparent",
  },
  leftBorder:{
    width: "1px",
    height: "16px",
    backgroundColor: "#D6D6D6",
    position: "absolute",
    left: "0",
    top: "50%",
    transform: "translate(0, -50%)",
  },
  rightBorder:{
    width: "1px",
    height: "16px",
    backgroundColor: "#D6D6D6",
    position: "absolute",
    right: "0",
    top: "50%",
    transform: "translate(0, -50%)",
  },
  titleText:{
    fontFamily: "Amx-Bold",
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "28px",
    color: "#000000",
    padding: "0",
    margin: "0 0 16px 0",
    textAlign: "center",
  },
  subTitleText:{
    fontFamily: "Amx-Regular",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    color: "#525252",
    padding: "0 32px",
    margin: "0 0 32px 0",
    textAlign: "center",
  },
  btnAccept:{
    textAlign: "center",
    display: "inline-block",
    backgroundColor: "#000" ,
    color: "#fff",
    paddingTop: "10px",
    paddingBottom: "10px",
    border: "0",
    borderRadius: "50px",
    margin: "0",
    width: "auto",
    minWidth: "51%",
    fontFamily: "Amx-Bold",
    fontSize: "16px",
    lineHeight: "24px",
  },
}